import createUsercryptApi from '@rhg/libs/api/create-usercrypt-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { queryKeys, useQuery } from '@rhg/libs/react-query';

export const conditionsQueryOptions = {
    queryKey: function () {
        return [queryKeys.conditions];
    },
    queryFn: async function (getAccessTokenSilently: () => Promise<string>) {
        const usercryptApi = createUsercryptApi(getAccessTokenSilently);

        const response = await usercryptApi.usercryptGetSupportedConditions({});

        return response.data;
    },
    queryOptions: function (isAuthenticated: boolean) {
        return {
            enabled: !!isAuthenticated,
            staleTime: Infinity,
        };
    },
};

export function useConditions() {
    const { isAuthenticated, getAccessTokenSilently } = useAuth();
    const { queryKey, queryFn, queryOptions } = conditionsQueryOptions;

    const { data, ...otherProps } = useQuery({
        queryKey: queryKey(),
        queryFn: async () => queryFn(getAccessTokenSilently),
        ...queryOptions(isAuthenticated),
    });

    return {
        conditions: data,
        ...otherProps,
    };
}
